import importerSelectors from 'modules/shared/importer/importerSelectors';

export default importerSelectors(
  'buildingLevel2.importer',
);
